.row {
	display: flex;
	gap: 10px;
	animation: msgIn 0.2s ease-out;
}

.rowUser {
	flex-direction: row-reverse;
}

.avatar {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	flex-shrink: 0;
	margin-top: 2px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
}

.avatar img {
	width: 100%;
	height: 100%;
}

.rowUser .avatar {
	display: none;
}

.body {
	max-width: 85%;
	min-width: 0;
	overflow-wrap: break-word;
	word-break: break-word;
	font-size: var(--parrot-chat-font-size-sm);
	line-height: 1.6;
}

.rowUser .body {
	background: var(--parrot-chat-user-bubble);
	color: #ffffff;
	border-radius: var(--parrot-chat-radius-bubble) var(--parrot-chat-radius-bubble) 4px var(--parrot-chat-radius-bubble);
	padding: 10px 14px;
	white-space: pre-wrap;
}

.rowAssistant .body {
	color: var(--parrot-chat-text);
}

/* Fills the row so the trace card and a streaming answer don't resize as text arrives. */
.bodyWide {
	flex: 1;
}

.interrupted {
	margin-top: 8px;
	color: var(--parrot-chat-error);
	font-size: 12px;
}

.rowError .body {
	color: var(--parrot-chat-error);
}

.markdown p { margin: 0 0 6px; }
.markdown p:last-child { margin: 0; }
.markdown h1, .markdown h2, .markdown h3 {
	font-size: 14px;
	font-weight: var(--parrot-chat-font-weight-bold);
	margin: 14px 0 6px;
	color: var(--parrot-chat-text);
}
.markdown h4, .markdown h5, .markdown h6 {
	font-size: 13px;
	font-weight: var(--parrot-chat-font-weight-bold);
	margin: 10px 0 4px;
	color: var(--parrot-chat-text);
}
.markdown ul, .markdown ol {
	margin: 2px 0 6px 16px;
	padding: 0;
}
.markdown li { margin: 2px 0; }
.markdown strong { color: var(--parrot-chat-text); font-weight: var(--parrot-chat-font-weight-bold); }
.markdown hr {
	border: none;
	border-top: 1px solid var(--parrot-chat-border);
	margin: 12px 0;
}
.markdown code {
	background: rgba(255, 255, 255, 0.06);
	padding: 1px 5px;
	border-radius: 4px;
	font-size: 12px;
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
.markdown pre {
	background: rgba(255, 255, 255, 0.04);
	border: 1px solid var(--parrot-chat-border);
	border-radius: var(--parrot-chat-radius);
	padding: 10px 12px;
	overflow-x: auto;
	margin: 8px 0;
}
.markdown pre code {
	background: transparent;
	padding: 0;
	border-radius: 0;
}
.markdown a {
	color: var(--parrot-chat-link);
	text-decoration: underline;
	text-decoration-color: rgba(137, 130, 231, 0.3);
	transition: text-decoration-color 0.15s;
	word-break: break-all;
}
.markdown a:hover {
	text-decoration-color: var(--parrot-chat-accent);
}
.markdown table {
	border-collapse: collapse;
	margin: 8px 0;
	font-size: 12px;
}
.markdown th, .markdown td {
	border: 1px solid var(--parrot-chat-border);
	padding: 4px 8px;
	text-align: left;
}

.typing {
	display: inline-flex;
	gap: 4px;
	padding: 8px 0;
	align-items: center;
	height: 28px;
}
.typing span {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: var(--parrot-chat-text-muted);
	animation: typingDot 1.4s infinite;
}
.typing span:nth-child(2) { animation-delay: 0.2s; }
.typing span:nth-child(3) { animation-delay: 0.4s; }

@keyframes msgIn {
	from { opacity: 0; transform: translateY(6px); }
	to { opacity: 1; transform: translateY(0); }
}
@keyframes typingDot {
	0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
	30% { opacity: 1; transform: translateY(-4px); }
}
